export class JobOwnershipJob {
    id!: string
    job!: string
    jobFullName!: string
    jobStatus!: number
    name!: string
    pmUserId!: number | undefined
    peUserId!: number | undefined
    siteSuperUserId!: number | undefined
    jcaUserId!: number | undefined
    hotCount!: number
    offTrackCount!: number
    lateCount!: number
    dueSoonCount!: number
    templateId!: string
}
